import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Loader2, XCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { loadUserProfile } from '../../redux/authentication/utils/core/authslice';

// Lands here after a successful Google/GitHub OAuth redirect -- the backend
// has already set access_token/refresh_token cookies by this point
// (oauth2.py's handle_oauth_user), so all this page does is hydrate Redux
// auth state from those cookies (GET /users/me) and move on. There is no
// token/code in the URL to parse; the cookies are the whole handoff.
const OAuthCallbackPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);
  const attempted = useRef(false);

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;

    dispatch(loadUserProfile())
      .unwrap()
      .then(() => navigate('/dashboard', { replace: true }))
      .catch(() => setFailed(true));
  }, [dispatch, navigate]);

  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center bg-[#09090f] px-4">
      <div className="max-w-md w-full p-10 bg-white/5 backdrop-blur-lg rounded-xl border border-white/10 shadow-lg text-center space-y-6">
        {!failed ? (
          <>
            <Loader2 className="mx-auto h-10 w-10 text-violet-400 animate-spin" />
            <p className="text-gray-300">{t('auth.oauthCallback.finishing')}</p>
          </>
        ) : (
          <>
            <XCircle className="mx-auto h-10 w-10 text-red-400" />
            <p className="text-red-300">{t('auth.oauthCallback.failed')}</p>
            <button
              onClick={() => navigate('/login', { replace: true })}
              className="mt-2 py-2 px-4 bg-violet-600 hover:bg-violet-700 text-white rounded-lg transition-colors"
            >
              {t('auth.returnToLogin')}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default OAuthCallbackPage;
